import { ApprovalConsiderationAnnounceElevenComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceElevenComponent";

export function ApprovalConsiderationAnnounceElevenContainer() {
    return (
        <ApprovalConsiderationAnnounceElevenComponent />
    )
}